import { RumInitConfiguration } from "@datadog/browser-rum";

export class DatadogResolver {
  static resolveConfig(
    environment: string,
    version: string | undefined
  ): RumInitConfiguration {
    const sbxEnvironments = ["dev", "local"];
    const useSbx =
      sbxEnvironments.includes(environment) ||
      (process.env["NODE_ENV"] === "development" &&
        process.env["REACT_APP_BUILD_NUMBER"] === "local");
    const env = useSbx ? "dev" : environment;

    const applicationId = useSbx ? "69af0638-bee9-41d8-b1d0-4659366db931" : "479c7660-22be-4d70-a327-1c619e0ddb87";
    const clientToken = useSbx ? "pub77a3768bd81ca17dc135da406c8cfa40" : "pub15de73bb988bb2fd51ec64d7aa398d6e";

    return {
      applicationId: applicationId,
      clientToken: clientToken,
      site: "datadoghq.com",
      service: "CCC Photo Upload SPA",
      env: env,
      version: version,
      sessionSampleRate: 100,
      sessionReplaySampleRate: 100,
      trackResources: true,
      trackLongTasks: true,
      trackUserInteractions: true,
    };
  }
}
